import type { ReactNode } from "react";

export interface ContractHighlight {
  text: string;
  color: string;
}

export function highlightContractText(text: string, highlights: ContractHighlight[]): ReactNode[] {
  if (!highlights.length) return [text];

  const parts: ReactNode[] = [];
  let remaining = text;
  let key = 0;

  for (const h of highlights) {
    const idx = remaining.indexOf(h.text);
    if (idx === -1) continue;
    if (idx > 0) parts.push(remaining.slice(0, idx));
    parts.push(
      <mark
        key={key++}
        className="rounded px-0.5 font-medium"
        style={{ backgroundColor: `${h.color}22`, color: h.color, border: `1px solid ${h.color}44` }}
      >
        {h.text}
      </mark>,
    );
    remaining = remaining.slice(idx + h.text.length);
  }

  if (remaining) parts.push(remaining);
  return parts;
}
